import { render, staticRenderFns } from "./Raise.vue?vue&type=template&id=39613285&scoped=true"
var script = {}
import style0 from "./Raise.vue?vue&type=style&index=0&id=39613285&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39613285",
  null
  
)

export default component.exports